import { fetchWithAuth } from './apiUtils';
import { getAuthToken } from './authService';
import { API_URL } from '../constants/api';

const API_BASE_URL = `${API_URL}/device-templates`;

/**
 * Servicio para gestión de plantillas de dispositivos
 */
const deviceTemplateService = {
  /**
   * Obtener todas las plantillas de un dispositivo específico
   * @param {string} deviceId - ID del dispositivo
   * @returns {Promise} - Promesa con la lista de plantillas
   */
  async getAllDeviceTemplates(deviceId) {
    if (!deviceId) {
      throw new Error('Device ID es requerido para obtener plantillas');
    }
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/${deviceId}`, {}, token);
  },

  /**
   * Crear una nueva plantilla de dispositivo
   * @param {string} deviceId - ID del dispositivo
   * @param {Object} templateData - Datos de la plantilla
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  async createDeviceTemplate(deviceId, templateData) {
    if (!deviceId) {
      throw new Error('Device ID es requerido para crear plantilla');
    }
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/${deviceId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateData),
    }, token);
  },

  /**
   * Actualizar una plantilla de dispositivo
   * @param {string} deviceId - ID del dispositivo
   * @param {string} templateId - ID de la plantilla
   * @param {Object} templateData - Datos actualizados de la plantilla
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  async updateDeviceTemplate(deviceId, templateId, templateData) {
    if (!deviceId || !templateId) {
      throw new Error('Device ID y Template ID son requeridos para actualizar plantilla');
    }
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/${deviceId}/${templateId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateData),
    }, token);
  },
};

export default deviceTemplateService; 